import React from "react";

import Navbar from "../../components/Navbar";
import AgentSvg from "../../assets/navbar/Agentes_on_light_blue.svg";
import { ImPlus } from "react-icons/im";
import * as S from "./styles";

import { useHistory, useLocation } from "react-router-dom";
import ListAgent from "../../components/ListAgent";

export default function AgentList() {
  const history = useHistory();
  const params = useQuery();

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  return (
    <>
      <Navbar />
      <S.Wrapper>
        <S.Header>
          <S.BoxUser>
            <S.Image src={AgentSvg} />
            <div>
              <S.Title>Agentes</S.Title>
              <S.Description>Cadastro geral de agentes</S.Description>
            </div>
          </S.BoxUser>

          <S.AddNew onClick={() => history.push("/cadastro-agentes")}>
            <ImPlus
              style={{
                margin: "0px 0px 30px",
              }}
            />
            <S.Image src={AgentSvg} />
          </S.AddNew>
        </S.Header>

        <ListAgent
          filter={params.get("filter") || ""}
          state={params.get("uf") || ""}
          stateName={params.get("ufName") || ""}
          type={params.get("type") || ""}
          pageFilter={parseInt(params.get("page") || "0")}
          history={history}
        />
      </S.Wrapper>
    </>
  );
}
